import React from 'react';

import { useTranslation } from 'react-i18next';

export const Empty = () => {
  const { t } = useTranslation('cart');

  return (
    <div
      className={`mx-auto flex h-[377px] w-full max-w-[1440px] flex-col items-center justify-center gap-y-2.5 rounded-[10px] bg-gray-10`}
    >
      <img src="/images/optimized/illusts/il_carts.webp" alt={t('empty')} />
      <span className="text-b3 text-gray-40">{t('empty')}</span>
    </div>
  );
};
